<template>
  <footer class="mt-4">
    <v-container class="content-container text-center">
      <v-row no-gutters>
        <v-col sm="2">
        </v-col>
        <v-col sm="8">
          <v-row>
            <v-col sm="4" class="text-center">
              <br /><br />
              <a href="#" @click.prevent="showPolicy">{{ $t('components.footer.policy')}}</a><br><br>
              <a href="mailto:info@pretopia.se">{{ $t('components.footer.contactUs')}}</a><br>
            </v-col>
            <v-col sm="4" class="d-flex flex-column align-center">
              <img src="/images/pretopia_hori_fylld_svart.png" style="max-width: 150px;" class="mt-6" alt="Pretopia" /><br><br>
              <div class="flex-grow-1"></div>
              <div class="mb-1">© 2024 Pretopia.</div>
              <div class="mb-1 grey--text">version: {{ version }}</div>
            </v-col>
            <v-col sm="4" class="text-center">
              <br>
              <h3>{{ $t('components.footer.followUs')}}</h3><br>
              <a href="https://www.instagram.com/pretopiabildbank" class="d-flex justify-center" target="_blank"><v-img style="max-width: 100px;" :src="'/images/instagram.png'"></v-img></a><br>
              <!-- <a href="//www.mynewsdesk.com/follow/102013" class="mynewsdesk-follow-button" data-width="170" data-tracking-action="" data-align="left" rel="nofollow">Följ Pretopia AB </a> -->
              <a href="https://www.mynewsdesk.com/se/pretopia-ab" target="_blank"><img src="/images/mynewsdesk-logo.svg" class="mynewsdesk-follow-button"></a>
            </v-col>
          </v-row>
        </v-col>
        <v-col sm="2">
        </v-col>
      </v-row>
    </v-container>
    
    <policy-dialog-component
        :visible="showPolicyDialog"
        @close="policyClosed()"></policy-dialog-component>

  </footer>
</template>

<script>
import PolicyDialogComponent from './dialog/PolicyDialogComponent.vue';

export default {
  components: {
    PolicyDialogComponent
  },

  data() {
    return {
      version: "20241222",
      showPolicyDialog: false
    }
  },

  methods: {
    showPolicy() {
      this.showPolicyDialog = true;
    },

    policyClosed() {
      this.showPolicyDialog = false;
    }
  }

}
</script>

<style scoped>
  footer {
    background-color: #ddd;
  }
  footer .content-container {
    padding: 20px 0;
  }
</style>

<style>
  .mynewsdesk-follow-button {
    /* margin-left: 62px; */
    margin-left: 14px;
    max-width: 120px;
  }
</style>
